export default __webpack_public_path__ + "static/media/chaosroom.45437027.jpg";